import { render, staticRenderFns } from "./tcustrelationship-add-or-update.vue?vue&type=template&id=a302eb7e&"
import script from "./tcustrelationship-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tcustrelationship-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports